<template>
	<div>
		<p>
			<b>{{ companyName }} hat dir folgende positive Nachricht geschickt</b>
		</p>
		<InfoBox class="my-3" :with-icon="false" type="purple-lightest">
			<nl2br tag="div" :text="text"/>
		</InfoBox>
		<p v-if="!sendOff">
			Wenn du auf <b>{{ buttonText }}</b> drückst, wird <b>{{ companyName }}</b> informiert und erhält für die
			näheren Detailabstimmungen deine E-Mail Adresse und deine Mobilnummer.
		</p>
		<div v-if="sendOff" class="mt-4">
			<ApplicantSendOff
				v-model="sendOffData"
				:customer="message.customer"
				:is-anonymous="false"
				:with-company-name="false"
			/>
			<div class="d-flex mt-4">
				<div class="flex-grow-1 mr-3">
					<a href="#" @click.prevent="sendOff = false">Bewerbung doch nicht zurückziehen</a>
				</div>
				<div>
					<Button
						text="Bewerbung zurückziehen"
						:disabled="!sendOffDataValid || sendingRequest"
						:loading="sendingRequest"
						@click="submit"
					/>
				</div>
			</div>
		</div>
		<div v-else class="d-flex align-items-center mt-4">
			<div class="flex-grow-1 mr-3">
				<a href="#" @click.prevent="sendOff = true">Bewerbung zurückziehen</a>
			</div>
			<div>
				<Button
					:text="buttonText"
					:disabled="sendingRequest"
					:loading="sendingRequest"
					icon="checkmark"
					@click="submit"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import * as Collaboration from "@/helper/communication/conversation/Collaboration"
import InfoBox from "@/vue/common/InfoBox";
import Button from "@/vue/common/Button";
import ApplicantSendOff from "@/vue/communication/conversation/ApplicantSendOff";
import {isDefined} from "@/helper/Value";
import Reply, {ACTION_COLLABORATION_ACCEPT, ACTION_SENDOFF} from "@/api/communication/conversation/message/Reply";
import flatten from "@/helper/error/Errors";
import * as Toast from "@/helper/layout/Toast";

const TEXT_MAPPING = {
	[Collaboration.INTEREST]: 'interest',
	[Collaboration.AGREEMENT_BASIC]: 'agreementBasic',
	[Collaboration.PROMISE]: 'promise',
	[Collaboration.AGREEMENT_FULL]: 'agreementFull',
};

const BUTTON_TEXTS = {
	[Collaboration.INTEREST]: 'Mein Interesse ebenfalls mitteilen für Folgeschritte',
	[Collaboration.AGREEMENT_BASIC]: 'Mein Interesse ebenfalls bestätigen für Folgeschritte',
	[Collaboration.PROMISE]: 'Meine Zusage ebenfalls mitteilen',
	[Collaboration.AGREEMENT_FULL]: 'Meine Zusage ebenfalls bestätigen',
};

export default {

	components: {
		ApplicantSendOff,
		Button,
		InfoBox,
	},

	props: {
		message: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		return {
			sendOff: false,
			sendingRequest: false,
			sendOffData: undefined,
		};
	},

	computed: {
		companyName ()
		{
			return this.message.customer.companyName;
		},
		text ()
		{
			const collaborationId = this.message.conversation.collaboration.id;

			return this.message.collaborationTexts[
				TEXT_MAPPING[collaborationId]
				];
		},
		buttonText ()
		{
			const collaborationId = this.message.conversation.collaboration.id;

			return BUTTON_TEXTS[collaborationId];
		},
		sendOffDataValid ()
		{
			return !this.sendOff || isDefined(this.sendOffData);
		}
	},

	methods: {
		async submit ()
		{
			this.sendingRequest = true;

			try
			{
				let action = this.sendOff
					? ACTION_SENDOFF
					: ACTION_COLLABORATION_ACCEPT;

				const reply = new Reply()
					.setMessageId(this.message.id)
					.setAction(action);

				if (this.sendOff)
				{
					reply.setCustomerUninterestingType(this.sendOffData.customerUninterestingType);
				}

				await reply.call();

				this.$emit('processed');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.sendingRequest = false;
		}
	}
}
</script>
